import { createSelector } from 'reselect';
import { getWorkOrderManagement } from './getWorkOrderManagement';

export const getLaborTicketActionLoading = createSelector(
  [getWorkOrderManagement],
  (workOrderManagement) => {
    return workOrderManagement.laborTicketActionLoading;
  }
);
